<template>
    <div v-for="dataToView of this.subEntity.displayContents" :key="dataToView">
        <div class="overall-champs">
            <h2>{{ dataToView.title }}</h2>
            <div class="d-flex flex-column gap-3" v-if="this.entity[dataToView.entityDataName].length != 0">
                <div class="win-container d-flex w-100 flex-row gap-4 py-3 px-3 align-items-center rounded-3"
                :class="`${ (index==0)?'bg-warning':(index==1)?'bg-secondary':(index==2)?'bg-info':''}`"
                @click="showModal(win)"
                    v-for="win, index of this.entity[dataToView.entityDataName]" :key="index">
                    <div class="relative d-flex flex-row justify-content-between align-items-center flex-grow-1" >
                        <!-- <span>{{ index+1 }}</span> -->
                        <span class="fs-4">{{ win.entity_name }}</span>
                        <span class="fs-4">{{ win.points }}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center" v-else>
                <h4 class="h2">* * * No Records * * *</h4>
            </div>
        </div>

    <div v-if="isShow">
        <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Guild Members of <span class="text-info">{{
                                    selectedGuild.entity_name
                                }}</span>
                            </h5>
                            <span aria-hidden="true" role="button" @click="closeModal"><i class="fas fa-xmark"></i></span>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex w-100 flex-column align-items-center gap-2">
                            <span class="fs-4" v-if="selectedGuild.members.length <= 0"> 
                                    * No members * 
                                </span>
                                <div class="border rounded w-75 px-2 d-flex justify-content-between" v-for="member of selectedGuild.members" :key="member"><span class="fs-4">{{ member?.character_id }}</span><span class="fs-4">{{ member?.character?.name }}</span></div>
                                
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeModal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "Hackathon",
        data() {
            return {
                selectedSeason: 3,
                selectedEvent: 0,
                isShow:false,
                selectedGuild:{}
                // entity: {
                //     champion: [{ guild_name: "GuildNgaToEh" }]
                // },
                // subEntity: {
                //     displayContents: [
                //         {
                //             entityDataName: "champion",
                //             title: "Seasonal Champion"
                //         },
                //     ]
                // }
            }
        },
        methods: {
            getValuebykey(obj, value) {
                return Object.keys(obj).find(key => obj[key] === value)
            },
            showModal(guild){
                this.isShow = true;
                this.selectedGuild = guild
                //Lookup for the members here
            },
            closeModal(){
                this.isShow=false;
            }
        },
        props: {
            entity: Object,
            subEntity: Object
        },
    }
</script>

<style></style>